import React from "react";
import Day from "shared/CalendarView/Day.shared";
import Month from "features/CalendarView/Month";
import { DateHelper } from "shared/helpers/DateHelper";

export default class MonthShared extends React.Component {
  shouldComponentUpdate(nextProps) {
    const monthNum = nextProps.monthData.monthNum % 12;
    const isSelectedMonth =
      monthNum === nextProps.dateHelper.getMonthBox(nextProps.selectedDate);
    const wasSelectedMonth =
      monthNum === nextProps.dateHelper.getMonthBox(this.props.selectedDate);

    const calNotesChanged = nextProps.calnoteObj !== this.props.calnoteObj;
    const selectedChanged = nextProps.selectedDate !== this.props.selectedDate;
    return (
      this.props.itemType ||
      calNotesChanged ||
      ((isSelectedMonth || wasSelectedMonth) && selectedChanged) ||
      this.props.itemType !== nextProps.itemType ||
      this.props.monthData !== nextProps.monthData
    );
  }

  isHighlighted(dayDate) {
    const { itemType, selectedDate, activeDate } = this.props;
    const result =
      itemType === "task" &&
      dayDate.getTime() <= selectedDate.getTime() &&
      selectedDate.getTime() !== this.props.dateHelper.date.getTime() &&
      (!activeDate || dayDate.getTime() >= activeDate);
    return result;
  }

  isSelected(dayDate) {
    const { selectedDate } = this.props;
    return selectedDate && selectedDate.getTime() === dayDate.getTime();
  }

  isActive(dayDate) {
    const { activeDate } = this.props;
    return activeDate && activeDate.getTime() === dayDate.getTime();
  }

  isToday(date) {
    const { dateHelper, isCurrentMonth } = this.props;
    return (
      isCurrentMonth &&
      date.getMonth() === dateHelper.date.getMonth() &&
      date.getDate() === dateHelper.date.getDate()
    );
  }

  daysInMonth() {
    const {
      monthData,
      dateHelper,
      setSelectedDate,
      selectedDate,
      activeDate,
      setActiveDate,
      itemType,
      calnoteObj,
    } = this.props;
    const days = monthData.days;
    return (
      <>
        {days.map((day) => {
          const dayDate = new Date(
            monthData.year,
            monthData.monthNum % 12,
            day
          );
          const dateString = DateHelper.dateString(dayDate);

          return (
            <Day
              key={day}
              date={dayDate}
              itemType={itemType}
              dateHelper={dateHelper}
              isToday={this.isToday(dayDate)}
              isOverflow={false}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              activeDate={activeDate}
              setActiveDate={setActiveDate}
              isSelected={this.isSelected(dayDate)}
              isActive={this.isActive(dayDate)}
              calendarNotes={calnoteObj[dateString]}
              isHighlighted={this.isHighlighted(dayDate)}
              hasMonthNameSuperscript={day === 1 && this.props.isCondensed}
              isInCondensedCal={this.props.isCondensed}
              
              //native only
              animatedIndexHelper={this.props.animatedIndexHelper}
            />
          );
        })}
      </>
    );
  }

  overflowDays() {
    const {
      monthData,
      dateHelper,
      setSelectedDate,
      selectedDate,
      activeDate,
      setActiveDate,
      itemType,
      calnoteObj,
      isCurrentMonth,
    } = this.props;
    const overflow = monthData.overflow;
    return (
      <>
        {overflow.days && (
          <>
            {overflow.days.map((day) => {
              let dayDate = new Date(
                overflow.year,
                overflow.monthNum % 12,
                day
              );
              let dateString = DateHelper.dateString(dayDate);
              return (
                <Day
                  key={day}
                  itemType={itemType}
                  date={dayDate}
                  dateHelper={dateHelper}
                  isToday={this.isToday(dayDate)}
                  isCurrentMonth={isCurrentMonth}
                  isOverflow={true}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  activeDate={activeDate}
                  setActiveDate={setActiveDate}
                  isSelected={this.isSelected(dayDate)}
                  isActive={this.isActive(dayDate)}
                  calendarNotes={calnoteObj[dateString]}
                  isHighlighted={this.isHighlighted(dayDate)}
                  hasMonthNameSuperscript={day === 1 && this.props.isCondensed}

                  //native only
                  animatedIndexHelper={this.props.animatedIndexHelper}
                />
              );
            })}
          </>
        )}
      </>
    );
  }
  render() {
    const name = this.props.monthData.name + " " + this.props.monthData.year;
    return (
      <Month {...this.props} {...{ name }}>
        {this.overflowDays()}
        {this.daysInMonth()}
      </Month>
    );
  }
}
